import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-work-order-items-modal',
  templateUrl: './work-order-items-modal.component.html',
})
export class WorkOrderItemsModalComponent implements OnInit {
  @Input() public contentType: 'detail' | 'list' = 'list';
  @Input() public filters: any;
  @Input() public disabledColumns: any;
  @Input() public disabledButtons: any;
  @Input() public pk: any;
  @Input() public defaults: any;
  @Input() public mode = 'normal';
  @Input() public entityFilters: any;

  constructor(public modal: NgbActiveModal) { }

  public ngOnInit(): void {}
}
